import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import DocumentoPrincipal from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/DocumentoPrincipal'
import DocumentosAnexos from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/DocumentosAnexos'
// import DocumentoPrincipalNew from './components/DocumentoPrincipalNew'

function Adjuntos(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.adjuntos')}>
      {/* <DocumentoPrincipalNew /> */}
      <DocumentoPrincipal />
      <DocumentosAnexos />
    </FieldsetGroup>
  )
}

export default Adjuntos
